import React, { useMemo, useEffect, useState } from "react";
import { AppProvider as PolarisAppProvider } from "@shopify/polaris";
import createApp from "@shopify/app-bridge";
import { SHOPIFY_API_KEY } from "../config/env";

export const AppBridgeContext = React.createContext(null);
export const AppBridgeConfigContext = React.createContext(null);

export default function AppBridgeProviderWrapper({ children }) {
  const config = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const host = urlParams.get("host");
    const shop = urlParams.get("shop");
    const apiKey = SHOPIFY_API_KEY;

    if (!apiKey) {
      console.warn("Shopify API key is not configured");
      return null;
    }

    if (!host) {
      console.warn("Host parameter is missing from URL");
      return null;
    }

    return {
      apiKey: apiKey,
      host: host,
      forceRedirect: process.env.NODE_ENV === "production",
      shop: shop,
    };
  }, []);

  const [app, setApp] = useState(null);

  useEffect(() => {
    if (config) {
      try {
        const appInstance = createApp(config);
        setApp(appInstance);
        if (typeof window !== "undefined") {
          window.__shopifyAppBridgeInstance = appInstance;
        }
      } catch (error) {
        console.error("Failed to create App Bridge app:", error);
        if (typeof window !== "undefined") {
          window.__shopifyAppBridgeInstance = null;
        }
      }
    } else {
      if (typeof window !== "undefined") {
        window.__shopifyAppBridgeInstance = null;
      }
    }

    return () => {
      if (typeof window !== "undefined") {
        window.__shopifyAppBridgeInstance = null;
      }
    };
  }, [config]);

  const contextValue = useMemo(() => config, [config]);

  if (!config) {
    return (
      <PolarisAppProvider i18n={{}}>
        <AppBridgeConfigContext.Provider value={null}>
          <AppBridgeContext.Provider value={null}>{children}</AppBridgeContext.Provider>
        </AppBridgeConfigContext.Provider>
      </PolarisAppProvider>
    );
  }

  return (
    <PolarisAppProvider i18n={{}}>
      <AppBridgeConfigContext.Provider value={contextValue}>
        <AppBridgeContext.Provider value={app}>{children}</AppBridgeContext.Provider>
      </AppBridgeConfigContext.Provider>
    </PolarisAppProvider>
  );
}
